var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02528 0 0 4.02564 0 9C0 13.9747 4.02564 18 9 18C13.9747 18 18 13.9744 18 9C18 4.02528 13.9744 0 9 0ZM9 16.5938C4.80259 16.5938 1.40625 13.1971 1.40625 9C1.40625 4.80259 4.80287 1.40625 9 1.40625C13.1974 1.40625 16.5938 4.80287 16.5938 9C16.5938 13.1974 13.1971 16.5938 9 16.5938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.53125C8.61166 4.53125 8.29688 4.84604 8.29688 5.23437V9.76224C8.29688 10.1506 8.61166 10.4654 9 10.4654C9.38834 10.4654 9.70312 10.1506 9.70312 9.76224V5.23437C9.70312 4.84604 9.38834 4.53125 9 4.53125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.2246C9.52424 13.2246 9.94922 12.7996 9.94922 12.2754C9.94922 11.7512 9.52424 11.3262 9 11.3262C8.47576 11.3262 8.05078 11.7512 8.05078 12.2754C8.05078 12.7996 8.47576 13.2246 9 13.2246Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationWhite);
export default __webpack_public_path__ + "static/media/exclamation-white.6c347c20d3ee4607ce7a57e07a20a2ab.svg";
export { ForwardRef as ReactComponent };